import { IDiagnosisInitialState } from '../../utils/Interface/DiagnosisInterface';

export const DIAGNOSIS_INITIAL_STATE: IDiagnosisInitialState = {
    diagnosis: { name: '' },
    diagnoses: [],
};
